<app-modal [dismissible]="false"
           class="popup-info">
    <div class="modal-header" modal-header>
        <h5 [innerHTML]="getTitle()"></h5>
    </div>
    <div class="modal-body" modal-body>
        <ng-container *ngIf="tools">
            <app-tool-scan-tree
                [isMaterial]="true"
                mode="display"
                [items]="tools">
            </app-tool-scan-tree>
        </ng-container>
    </div>
    <div class="modal-footer" modal-footer>
        <app-button type="simple"
                    (click)="modal.close()">
            {{ 'generic.buttons.close' | translate }}
        </app-button>
        <div class="actions-btns">
            <app-button type="primary"
                        class="btn btn-primary"
                        (click)="onClickSelection(true)">
                {{ 'lineSetter.tool-returns.pages.ersaBayModal.buttons.yes'| translate }}
            </app-button>
            <app-button type="primary"
                        class="btn btn-primary"
                        [disabled]="areAllToolsNeededAtErsa"
                        (click)="onClickSelection(false)">
                {{ 'lineSetter.tool-returns.pages.ersaBayModal.buttons.no' | translate }}
            </app-button>
        </div>
    </div>
</app-modal>
